import { useState } from "react";
import ReactPlayer from "react-player";
import SelectThemeModal from "../modal/SelectThemeModal"; // Создадим его отдельно

const WebinarCard = ({ id, title = "Без названия", createdAt, videoPreview, videoUrl }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSelectThemeOpen, setIsSelectThemeOpen] = useState(false);

    return (
        <>
            <div
                className="relative shrink-0 basis-[278px] bg-lavender-8 rounded-2xl p-2 cursor-pointer hover:shadow-lg transition-shadow"
                onClick={() => setIsModalOpen(true)}
            >
                <div className="relative w-full min-h-[123px] bg-lavender rounded-xl flex items-end p-2 gap-1">
                    {videoPreview ? (
                        <img src={videoPreview} alt="Превью вебинара" className="w-full h-full object-cover rounded-xl" />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center bg-gray-200 rounded-xl">
                            <span className="text-gray-500 text-sm">Нет превью</span>
                        </div>
                    )}
                </div>
                <div className="py-4 px-2 leading-5">
                    <h4 className="font-semibold">{title}</h4>
                    <p className="text-xs text-gray-500">{new Date(createdAt).toLocaleDateString()}</p>
                </div>
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-xl w-[600px]">
                        <h2 className="text-xl font-bold mb-4">{title}</h2>
                        {videoUrl ? (
                            <ReactPlayer url={videoUrl} controls width="100%" height="350px" playing />
                        ) : (
                            <p className="text-center text-gray-500">Запись отсутствует</p>
                        )}
                        <div className="flex justify-between mt-4">
                            <button
                                onClick={() => setIsModalOpen(false)}
                                className="px-4 py-2 bg-red-500 text-white rounded-md"
                            >
                                Закрыть
                            </button>
                            <button
                                onClick={() => {
                                    setIsModalOpen(false);
                                    setIsSelectThemeOpen(true);
                                }}
                                className="px-4 py-2 bg-blue-500 text-white rounded-md"
                            >
                                Добавить в тему
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Модалка выбора темы */}
            {isSelectThemeOpen && (
                <SelectThemeModal
                    isOpen={isSelectThemeOpen}
                    onClose={() => setIsSelectThemeOpen(false)}
                    webinarId={id} // Передаём ID вебинара
                    webinarTitle={title}
                    webinarUrl={videoUrl}
                />
            )}
        </>
    );
};

export default WebinarCard;
